const NETWORK_ERROR_MESSAGES = [
  'Failed to fetch', // Chrome/Edge
  'NetworkError when attempting to fetch resource', // Firefox
  'Load failed', // Safari
  'Network request failed', // React Native
];

export default function isNetworkError(err: unknown) {
  if (
    err instanceof TypeError &&
    // .startsWith because Sentry appends the host to the error message
    NETWORK_ERROR_MESSAGES.some((msg) => err.message.startsWith(msg))
  ) {
    return true;
  }
  if (typeof err === 'object' && (err as any)?.code === 'NetworkError') {
    return true;
  }
  return false;
}
